import FileSize from "../../components/commonComponent/FileSize";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import useFocusPageStart from "../../hooks/useFocusPageStart";
import Breadcrumb from "../schemes/components/Breadcrumb/Breadcrumb";
import { updates } from "../landing/data/dashboardData";
import { PdfPreviewModal } from "../rightToInformation/components/RtiContent/PdfDocumentTable";

const UPDATES_PAGE_TITLE = "Updates";
const UPDATES_PAGE_HEADING = UPDATES_PAGE_TITLE;

const PdfBadge = () => (
  <span className="relative inline-block h-5 w-4 shrink-0 rounded-[2px] bg-[#dfe5ea] shadow-[0_1px_2px_rgba(0,0,0,0.16)]">
    <span className="absolute right-0 top-0 h-0 w-0 border-b-[6px] border-l-[6px] border-b-[#c7d0d8] border-l-transparent" />
    <span className="absolute left-1/2 top-[10px] -translate-x-1/2 rounded-[2px] bg-[#ff5145] px-[2px] py-[1px] text-[6px] font-bold leading-none text-white">
      PDF
    </span>
  </span>
);

const PageTitle = () => (
  <h1 className="m-0 text-[22px] font-bold leading-[1.2] uppercase tracking-[0.5px] text-[#16376c] md:text-[24px] first-letter:text-[#ff9933]">
    {UPDATES_PAGE_HEADING}
  </h1>
);

const UpdatesList = () => {
  const navigate = useNavigate();
  const [selectedUpdate, setSelectedUpdate] = useState(null);

  return (
    <>
      <div className="space-y-3">
        {updates.map((item) => (
          <button
            key={item.title}
            type="button"
            onClick={() => item.route ? navigate(item.route) : setSelectedUpdate(item)}
            disabled={!item.href && !item.route}
            title={item.title}
            aria-label={`Open ${item.title}`}
            className="flex min-h-[44px] w-full items-center justify-between gap-4 rounded-full bg-white px-4 py-3 text-left outline-none transition-colors hover:bg-[#f2f6fc] focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-70 md:px-5"
          >
            <span className="flex min-w-0 items-center gap-2">
              <PdfBadge />
              <span className="break-words text-[12px] font-bold leading-5 text-[#16376c] underline underline-offset-2 sm:text-[13px]">
                {item.title}<FileSize href={item.href} fileName={item.fileName} />
              </span>
            </span>

            <span className="shrink-0 text-[12px] text-[#7d7f86] " >
              {item.date}
            </span>


          </button>
        ))}
      </div>

      {selectedUpdate && (
        <PdfPreviewModal
          pdfDocument={selectedUpdate}
          onClose={() => setSelectedUpdate(null)}
        />
      )}
    </>
  );
};

const UpdatesPage = () => {
  useFocusPageStart("/updates");

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: UPDATES_PAGE_TITLE, path: "/updates" },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-[#f5f5f5]">
      <SiteHeader className="shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        <div className="z-[1000] px-5 pt-2 pb-3 md:px-10 md:pb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </SiteHeader>

      <main
        id="main-content"
        data-readable-content
        tabIndex={-1}
        className="flex-1 outline-none"
      >
        <section className="mx-auto w-full max-w-[1400px] px-5 pb-16 pt-5 md:px-10 md:pb-24 md:pt-6">
          <PageTitle />

          <div className="mt-5">
            <UpdatesList />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default UpdatesPage;
